<template>
    <el-dialog class="file-view" title="选择附件" :close-on-click-modal="false" center style="font-family: NotoSansHans-Regula; font-size:24px; color:#333;z-index:99999999999" :visible.sync="viewTechnologyDialogVisible" width="30%" >
        <div class="table_searchbar">
            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="" @keydown.enter="search()">
                    <span class="title">文件名：</span>
                    <el-input :style="W?{maxWidth:'180px'}:{maxWidth:'150px'}" size="small"  v-model="fileName" maxlength="100" placeholder="文件名"></el-input>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div style="text-align:right">
                        <el-button size='mini' icon="el-icon-search" type="primary" @click="search()">查询</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-row style='margin: 15px 0;'>
            <span style="font-size:12px">默认只显示20个附件，可输入文件名搜索你要的附件</span>
        </el-row>
        <el-table :data="tableData"  :height="tableData.length>=7?322:'auto'"  empty-text='暂无相关文件' style="width: 100%;max-height: 322px;overflow: hidden;overflow-y: auto;"
            @row-click='rowClick'  :row-class-name="tableRowClassName" :row-style='selectedHighlight' @click.stop="deleteVisible = true">
            <el-table-column  label="文件名称" min-width="200" show-overflow-tooltip>
                <template slot-scope="scope" @click.stop="deleteVisible = true">
                    <div class="radio" :style="scope.row.id==selectId?{background:'#409EFF',border: '1px solid #409EFF'}:{}">
                        <div class="point"></div>
                    </div>{{scope.row.fileName}}
                </template>
            </el-table-column>
            <el-table-column prop="userName" label="操作人" min-width="80" show-overflow-tooltip></el-table-column>
        </el-table>
        <span  slot="footer" class="el-dialog__footer" style="text-align: center;" center >
            <el-upload :action="uploadUrl" :before-upload='beforeUpload'  :on-success="uploadComplete" :show-file-list='false' style='display: inline-block;margin-right:10px'>
                    <el-button  type="primary" size="small"  v-if="permission.btn_file_upload" >重新上传</el-button>
            </el-upload>
            <el-button type="primary" @click="selectFile" >确 定</el-button>
            <el-button  @click="cancalViewTechnology">取 消</el-button>
        </span>
    </el-dialog>
</template>

<script>
let parent = null
export default {
    name: "FileView",
    data() {
        return {
            flieType:-100,
            selectId:null,
            tableData:[],
            fileName:'',
            selectData:null,
            viewTechnologyDialogVisible:false,
            W:false,
            getIndex:null,
            sendData:null,
            permission:JSON.parse(localStorage.getItem("permission"))
        };
    },
    async mounted() {
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
    },
    computed:{
        span(){
           return this.W?5:7
        },
        uploadUrl:function(scope){
            let res = "/api/file/upload?token="+localStorage.getItem("token")+"&fileType="+this.flieType;
            return res
        },
    },
    methods: {
        rowClick(row, column, event){
            this.selectData = row
            if(this.getIndex==row.index){
                this.getIndex = null
                this.selectData = null
                this.selectId = null
            }else{
                this.getIndex=row.index
                this.selectId = row.id
            }
        },
        
        selectedHighlight({row, rowIndex}) {
            if ((this.getIndex) === rowIndex ) {
                return {
                    "background-color": "#faf2d4",
                    'color':'#409EFF'
                };
            }else{
                return {}
            }
        },

        tableRowClassName ({row, rowIndex}) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },

        async selectFile(){
            if(this.selectData){
                if(this.$parent.uploadComplete){
                    let response ={}
                    response.data = this.selectData
                    if(this.sendData&&this.sendData.deviceId){
                        let {fileType, deviceId,deviceTypeId}= this.sendData
                        let fileId = this.selectData.id
                        let {code,data,msg,message} = await this.$RequestUtil.postAsync({ url: '/api/maintenanceSchedule/uploadFile', type:'sync', params: {fileType, deviceId,deviceTypeId,fileId},})
                        response.code = code
                        response.msg=msg
                        response.message = message
                    }
                    this.$parent.uploadComplete(response,this.sendData)
                }
                this.sendData = null
                this.selectData = null
                this.getIndex = null
                this.fileName = null
                this.selectId = null
                this.viewTechnologyDialogVisible = false
            }else{
                this.$message.warning('请先选择文件')
            }
        },

        async reload() {
            this.initView();
        },

        async loadDeviceTypeList(){
            let {data,code,msg,message}=await this.$RequestUtil.getAsync({ url: '/api/device/listDeviceType', type:'sync', params: {},})
            if(code==0){
                this.deviceType = data
            }else{
                this.$message.error(msg||message)
            }
        },

        async loadFileList(fileName){
            let {data,msg,code,message} = await  this.$RequestUtil.getAsync({ url: '/api/fileSys/getFileList', type:'sync', params: {type:this.flieType,fileName,pageNum:1,pageSize:20,},})
            if(code==0){
                this.tableData = data
            }else{
                this.$message.error(msg||message)
            }
        },

        async initView(data,fileType) {
            this.selectData = null
            this.getIndex = null
            this.fileName = null
            this.selectId = null
            this.sendData = data
            if(fileType!=undefined){
                this.flieType = fileType
            }
            log(data,fileType,666)
            await this.loadFileList()
            this.viewTechnologyDialogVisible = true 
        },

        async search(){
            await this.loadFileList(this.fileName)
        },

        cancalViewTechnology(){
            this.procedureData =[]
            this.parameterData = []
            this.viewTechnologyDialogVisible = false
        },

        beforeUpload(file){
            if(!this.permission.btn_file_upload){
                this.$message({
                    type:'error',
                    message:`抱歉，您暂无文件上传权限`
                })
                return false
            }
            let fileSize = file.size/1024/1024
            fileSize = Math.round(fileSize*100)/100
            if(fileSize>=10){
                this.$message({
                    type:'error',
                    message:`文件大小不能超过10M,当前上传${file.name}大小为${fileSize}M`
                })
                 return false
            }
        },

        uploadComplete:async function(response, file, fileList) {
            if(response.code==0){
                this.$message({
                    type:'success',
                    message:'上传成功'
                })
                if(this.$parent.uploadComplete){
                    if(this.sendData&&this.sendData.deviceId){
                        let {fileType, deviceId,deviceTypeId}= this.sendData
                        let fileId = response.data.id
                        let {code,data,msg,message} = await this.$RequestUtil.postAsync({ url: '/api/maintenanceSchedule/uploadFile', type:'sync', params: {fileType, deviceId,deviceTypeId,fileId},})
                        response.code = code
                        response.msg=msg
                        response.message = message
                    }
                    this.$parent.uploadComplete(response,this.sendData)
                }
                this.viewTechnologyDialogVisible = false
                this.fileName=''
                this.search()
            }else{
                this.$message.error(response.msg||response.message)
            }
        },
        
        showFile:function(url){
            if(!this.permission.btn_file_get){
                this.$message({
                    type:'error',
                    message:`抱歉，您暂无文件读取权限`
                })
                return false
            }
            if(!url){
                this.$message.warning('当前文件不存在')
                return
            }
            let index = url.lastIndexOf(".");
            let ext = url.substr(index+1).toLowerCase();
            //可直接被浏览器打开的文件类型
            let arr = ['pdf','png','jpg','svg','txt','html','js','art','au','aiff','xbf','jpeg']
            if(arr.includes(ext)){
                window.open(url,'_blank');
            }else{
                window.location.href = url;
            }
        },

        getFilePath(fileName){
            if(!fileName){
                return
            }
            let filePath = ''
            let arr = fileName.split('.')
            let suffix = arr[arr.length-1]
            switch(true){
                case suffix == 'pdf'||suffix=='pptx':
                    filePath = '../../static/img/pdf.png'
                    break
                case suffix == 'png'|| suffix == 'jpg' || suffix == 'svg':
                   filePath = '../../static/img/pic.png'
                   break
                case suffix == 'txt'||suffix=='doc'||suffix=='docx':
                    filePath = '../../static/img/txt.png'
                    break
                default:
                  filePath = '../../static/img/file.png'
            }
            return filePath
        },
    }
};
</script>
<style  scoped>
    .key{
        font-size: 16px;
        color:#c0c4cc;
        font-family: NotoSansHans-Regula;
        padding-right:10px;
    }
    .value{
        font-size:16px;
        color:#999;
        font-family: NotoSansHans-Regula;
    }
    .radio{
        width: 14px;
        height: 14px;
        border-radius: 100%;
        border: 1px solid #ccc;
        display:inline-block;
        position: relative;
        top: 2px;
        background:#fff;
        margin-right: 5px;
    }
    .point{
        position: absolute;
        left: 4px;
        top: 4px;
        background: #fff;
        width: 4px;
        height: 4px;
        border-radius: 100%;
    }
    .el-table tbody tr:hover .radio{
        background:#409EFF;
        border: 1px solid #409EFF;
    }
</style>
<style>
   .file-view .el-table tbody tr:hover>td { 
        background-color:#faf2d4 !important;
        cursor: pointer;
        color: #409EFF;
    }
</style>




// WEBPACK FOOTER //
// src/components/common/FileView.vue